import React, { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import {VariableSizeList as List} from 'jd-library/ReactVirtualWindow';
import {reactWindowHelper} from 'jd-library/ReactVirtualWindow';
import SliderWrapper from 'jd-library/SliderWrapper';
import SliderHeader from "jd-library/SliderHeader";
import historyHandler from "jd-library/historyHandler";
import Button from "jd-library/Button";
import withRipple from "jd-library/withRipple";
import { setCategoryList } from "../../../actions/items";
import CategoryListItem from "./CategoryListItem.js";
import ItemCatSlider from "../../../common/ItemCatSlider/item-category-sliders/ItemCatSlider.js"
import RevealAnimation from '../../../common/transition/Animation';
import FullWidthButton from 'jd-library/FullWidthButton';
import styles from './categoryListItem.scss';
import { withPortal } from "jd-library";

const headerData = {
    default: 'Select Display Category'
};

const Row = React.memo(({ style, index, data }) => {
    let { list, scrollRef, itemSize, selectCategory, toggleChildCat, updateChild,selectedCatID,updateSelectedCatID ,useCategorySlider, fromDiscount=false} = data;
    let keysArr = Object.keys(list);
    let values = list[keysArr[index]];
    let displayLabel = values.productGroupName;
    return (
        <div style={{
            ...style,
            transform: 'translate3d(0 ,0 , 0)'
        }} key={index}>
            <CategoryListItem
                displayLabel={displayLabel}
                data={values}
                itemSize={itemSize}
                selectCategory={selectCategory}
                toggleChildCat={toggleChildCat}
                updateChild={updateChild} 
                scrollRef={scrollRef}
                selectedCatID={selectedCatID}
                updateSelectedCatID={updateSelectedCatID}
                useCategorySlider={useCategorySlider}
                fromDiscount={fromDiscount}
                />
        </div>
    )
}, reactWindowHelper.areEqual)

let remFontSize = 16;
if (typeof window !== "undefined") {
    remFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
}
const CategorySlider = (props) => {
    const [isSearching, updateIsSearching] = useState(true);
    const [parentCat, toggleParentCat] = useState(false);
    const [childCat, toggleChildCat] = useState(false);
    const [selectedChidCat, updateSelectedChidCat] = useState({});
    const [showSaveButton,updateShowSaveButton] = useState(false);
    const [newParCatAdded,setNewParCatAdded] = useState(false);
    const [listUpdated,setListUpdated] = useState(false);
    const [autoScroll,setAutoScroll] = useState(true);
    const [selectedCatValue,updateSelectedCatValue] = useState({});
    const [selectedCatID,updateSelectedCatID] = useState(props.selectedCatId || null);
    const listRef = useRef();
    let appliedOnIds = props.appliedOnIds || [];
    let rightSelectedIcon = <span className={`icon-pagination-right selected-child-icon ${styles['icon-pagination-right']} ${styles['selected-child-icon']}`}></span>;
    let displayChild = [];
    const [isScrolled, setScroll] = useState(
		typeof document === 'object' && (document.scrollingElement.scrollTop > 0)
    );
    const handleScroll = useCallback((e) => {
		setScroll(e.scrollOffset > 0);
    }, []);
    
    if(selectedChidCat.productGroupBreadCrumb){
        let childData = selectedChidCat.productGroupBreadCrumb.split('>>');
        for(let i=0;i<childData.length;i++){
            displayChild.push(<span className={styles['selected-child']}>{childData[i]}</span>);
            displayChild.push(rightSelectedIcon);
        }
    }
    
    const onSaveScroll = (value) =>{
        updateSelectedCatID(value.productGroupId);
    }
    let catSliderElements = [{
        onHidden: () => { 
            setNewParCatAdded(true);
            toggleParentCat(false);
        },
        headerText: 'Add Parent Category',
        inputLabel: 'Parent Category Name',
        inputKey: 'parentCatName',
        catType: 'parent',
        getCategoryData: (() => { 
            setAutoScroll(false);
            updateIsSearching(true);
        }),
        onSaveScroll:onSaveScroll
    }, {
        customHTML: (<div className={styles['selected-child-cat']}>{displayChild}</div>),
        onHidden: () => { 
            toggleChildCat(false);
        },
        headerText: 'Add Child Category',
        inputLabel: 'Child Category Name',
        inputKey: 'childCatName',
        catType: 'child',
        parentGroupId: selectedChidCat.productGroupId,
        getCategoryData: (() => { 
            setAutoScroll(true);
            updateIsSearching(true);
        }),
        onSaveScroll:onSaveScroll
    }];
    useEffect(() => {
        if (isSearching) {
            props.setCategoryList({
                appliedOnIds : appliedOnIds,
                cb: (data) => {
                    console.log('category', data);
                    if(selectedCatID && autoScroll){
                        setTimeout(() =>{
                            let index = window.categoryRef && window.categoryRef.categoryRef[selectedCatID][0];
                            listRef && listRef.current && listRef.current.scrollToItem(index, "start");
                        },300)
                    }
                }
            });
            updateIsSearching(false);
        }
    });
    useEffect(() =>{
        newParCatAdded && setListUpdated(true);
    },[props.printCategoryData]);
    const updateChild = (value) => {
        updateSelectedChidCat(value);
    }
    const saveCB = () =>{
        props.selectCategory(selectedCatValue);
        props.closeCatSlider();
        historyHandler.closeCurrent();
    }
    const selectedCatData = (value) =>{
        updateSelectedCatValue(value);
        updateShowSaveButton(true);
    }
    var listStyle = {
        paddingBottom:'60px'
    }

    const prepareList = (list = []) => {
        if(newParCatAdded && listUpdated){
            list.unshift(list.pop()); // moves the last element to first
            setNewParCatAdded(false);
            setListUpdated(false);
        }
        let keysArr = Object.keys(list);
        return <List
            // onScroll={handleScroll}
            ref={listRef}
            onScroll={handleScroll}
            height={(props.isMobile ? (window.innerHeight - 105) : window.innerHeight)}
            itemCount={Object.keys(list).length}
            itemSize={(index) => {
                return (((remFontSize * 1.75) + 20));
            }}
            width={props.isMobile ? window.innerWidth : '320px'}
            style={showSaveButton ? listStyle : null}
            itemData={{
                list,
                allCategories: props.editCategoryData,
                itemSize: ((remFontSize * 1.75) + 20),
                selectCategory: selectedCatData,
                toggleChildCat: toggleChildCat,
                updateChild: updateChild,
                scrollRef:listRef,
                selectedCatID:selectedCatID,
                updateSelectedCatID:updateSelectedCatID,
                useCategorySlider:props.useCategorySlider,
                fromDiscount: props?.fromDiscount || false
            }}
            overscanCount={30}
        >
            {Row}
        </List>;
    }
    let data = (
        <RevealAnimation>
            <>
                {props.useCategorySlider ? null
                : <AddCategory 
                    onAddClick = {() => { setTimeout(() => toggleParentCat(true), 300) }}
                    className={isScrolled ? 'scrolled' : ''}
                    rippleColor = 'rgba(19,144,211,0.1)'
                    isMobile = {props.isMobile}
                />}
                {prepareList(
                    props.printCategoryData
                )}
            </>
        </RevealAnimation>
    )
    const headerProps = {
        heading: props.useCategorySlider ? "Select Category" : headerData.default,
        variant: "secondary",
        raised: isScrolled,
        className: props?.showShadow ? '' : styles["cat-hdr"],
        leftIcons: props.fromDiscountList ? [] : [
            {
                className: 'icon-HDRback',
                onClick: e => {
                    props.closeCatSlider();
                    if(props.fromDiscountList){
                        historyHandler.closeAll();
                    }else{
                        historyHandler.closeCurrent();
                    }
                }
            }
        ],
        searchBox: false,
    };
    return (
        <>
            <SliderWrapper
                onHidden={() => {
                    props.closeCatSlider();
                }}
                  footer= {(props.useCategorySlider) ? {
                    fullWidthBtn: {
                        className: styles['category-button'],
                          onClick: () => {
                            if(props.selectedCategory.length){
                                props.updateCategoryProductId({
                                    appliedOnIds: props.selectedCategory
                                });
                                window.history.back();
                            }else{
                                props.showErrorToast && props.showErrorToast("Please Select Categories")
                            }
                        },
                          children: (
                            <>
                              <FullWidthButton.Section
                                variant='left'
                                text={<span style ={{"font-weight" : "400"}}>{`${props.selectedCategory.length} ${props.selectedCategory.length > 1 ? "Categories" : "Category"}`}</span>}
                                subText={"Selected"}
                              />
                              <FullWidthButton.Section
                                iconClass={'icon-BTNarrow'}
                                variant='right'
                                text={'Continue'}
                              />
                            </>
                          ),
                    }
                  } : {}}>
                <SliderHeader {...headerProps} />
                {data}
                {showSaveButton && <div className={styles['select-cat-btn-holder']}>
                    <Button
                        size='lg'
                        className={styles['select-cat-btn']}
                        clickHandler={saveCB}
                        raised
                    >
                        Save
                    </Button>
                </div>}
            </SliderWrapper>
            {parentCat ? <ItemCatSlider {...catSliderElements[0]} fromVendorWeb = {props.fromVendorWeb}/> : null}
            {childCat ? <ItemCatSlider {...catSliderElements[1]} fromVendorWeb = {props.fromVendorWeb}/> : null}
        </>
    )
}
const AddCategory = withRipple(props => {
    return(
        <div className={styles['add-category'] + ' ' + (!props.isMobile ? styles['add-category-web'] : '' ) + ' ' +props.rippleClass+' '+props.className} onClick={props.onAddClick} {...props.rippleHandler}>
                    <div className={`icon-plus ${styles['icon-plus']} ${styles['category-plus']}`}></div>
                    <div className={styles['add-category-text']}>Add Category</div>
                    {props.renderRipple()}
                </div>
    )
});
const mapStateToProps = (state, props) => {
    return {
        editCategoryData: state.items.editCategoryData,
        printCategoryData: state.items.printAllCat,
        isMobile: state.library.deviceData.isMobile,
        selectedCategory: state.items.selectedCategory,
        ...props
    }
}

export default withPortal(connect(
    mapStateToProps, {
    setCategoryList
}
)(CategorySlider));
